import { ContactUsRequest } from "@/types/patient";
import { UserSummary, UserUpdate } from "@/types/user";

import { requestData } from "@/api/api-config";

export async function updateUser(
  userId: string,
  user: UserUpdate,
  catchError: boolean = true,
): Promise<UserSummary | null> {
  return await requestData<UserSummary>(
    `user/update/${userId}`,
    "put",
    {
      json: user,
    },
    catchError,
  );
}

/** Merge keys into the current user's `meta` bag server-side (without
 * clobbering sibling keys). Used for per-user rollout prefs. */
export async function patchMyMeta(
  meta: Record<string, unknown>,
): Promise<UserSummary | null> {
  return await requestData<UserSummary>("user/me/meta", "patch", {
    json: { meta },
  });
}

export async function contactUs(
  data: ContactUsRequest,
): Promise<boolean | null> {
  return await requestData<boolean>("user/contact-us", "post", {
    json: data,
  });
}
